import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingSpinnerService {
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.isLoadingSubject.asObservable();

  get isLoading(): boolean {
    return this.isLoadingSubject.value;
  }

  show(): void {
    this.isLoadingSubject.next(true);
  }

  hide(): void {
    this.isLoadingSubject.next(false);
  }
}
